var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-warpper"},[_vm._v("Copyright 2021 ©三间有暖平台.All rights reserved.")])
}
var staticRenderFns = []

export { render, staticRenderFns }